$ = require 'jquery'
ArchiveView = require 'views/archive/archive-view'
BoardLabelsView = require 'views/board-menu/board-labels-view'
BoardMenuActivityView = require 'views/board-menu/board-menu-activity-view'
BoardSidebarDefaultView = require 'views/board-menu/board-sidebar-default-view'
boardSidebarTemplate = require 'views/templates/board_sidebar'
BoardSettingsView = require 'views/board-menu/board-settings-view'
BoardSettingsAndMoreView = require 'views/board-menu/board-menu-settings-and-more-view'
BoardMenuMoreView = require 'views/board-menu/board-menu-more-view'
BoardCollectionsView = require 'views/board-menu/board-collections-view'
Browser = require 'lib/browser'
CardFilterView = require 'views/board-menu/card-filter-view'
ChangeBoardBackgroundView = require 'views/board-menu/change-board-background-view'
ChangeBoardBackgroundSelectView = require 'views/board-menu/change-board-background-select-view'
Keys = require 'data/keys'
PopOver = require 'views/lib/pop-over'
StickerPickerView = require 'views/board-menu/sticker-picker-view'
Storage = require 'lib/storage'
UserInput = require 'views/internal/user-input'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
simpleTest = require 'lib/experiments/simple-test'
templates = require 'views/internal/templates'
track = require 'debug/track'

module.exports = class BoardSidebarView extends View

  initialize: ({ @boardView }) ->
    UserInput.addHandler @, { scope: 'board_sidebar' }
    @defaultView = @subview(BoardSidebarDefaultView, @model, sidebarView: @)
    @viewStack = [{ name: 'default', view: @defaultView }]
    if simpleTest('tabbedBoardMenu')?.get('tabbed')
      lastView = Storage.get(@_lastViewKey()) ? 'default'
      if @canRestoreTo(lastView)
        @resetTo(lastView, { animate: false, showSidebar: false })
    return

  events:
    'click .js-hide-sidebar': 'hideSidebar'
    'click .js-pop-widget-view': 'popView'
    'click .js-open-activity': (e) ->
      @defaultView.openActivity(e)
    'click .js-open-members': (e) ->
      @resetTo('default')
    'click .js-open-power-ups': (e) ->
      @defaultView.showPowerUps(e)
    'click .js-open-filter': (e) ->
      @defaultView.showCardFilter(e)
    'click .js-open-stickers': (e) ->
      @defaultView.openStickers(e)
    'click .js-open-settings': (e) ->
      Util.stop(e)
      @pushView 'settingsAndMore'
      track("Board Menu", "Settings and More Menu")
    'shortcut': 'shortcut'

  shortcut: (key) ->
    switch key
      when Keys.F
        @pushView 'filter'
        "F - Search and Filter Cards"

  className: 'board-menu-container'

  render: ->
    @$el.html(boardSidebarTemplate({
      useTabs: simpleTest('tabbedBoardMenu')?.get('tabbed')
      canAddPowerUps: @model.editable()
      canAddStickers: @model.editable()
    }))

    @renderView()

    @

  _lastViewKey: ->
    "initialMenu_#{ @model.id }"

  # These are the menus that we want to remember being on, and go back to
  # the next time the user visits the board
  # In particular, we can't restore to menus that used options to
  # configure the view, because we aren't storing what the options are.
  canRestoreTo: (name) ->
    name in [
      'default',
      'filter',
      'stickers',
      'labels',
      'activity',
      'powerUps',
      'more',
      'settings',
      'settingsAndMore'
    ]

  # Because of these classes aren't yet defined, we need to make this a
  # function. When we get proper requiring, this can become a normal object.
  sidebarSubviews: ->
    default: BoardSidebarDefaultView
    filter: CardFilterView
    archive: ArchiveView
    stickers: StickerPickerView
    labels: BoardLabelsView
    background: ChangeBoardBackgroundView
    backgroundColors: ChangeBoardBackgroundSelectView
    backgroundPhotos: ChangeBoardBackgroundSelectView
    activity: BoardMenuActivityView
    more: BoardMenuMoreView
    settings: BoardSettingsView
    settingsAndMore: BoardSettingsAndMoreView
    collections: BoardCollectionsView

  hackySidebarLifetimeEvents:
    filter:
      didBecomeVisible: (view) ->
        input = view.$('.js-autofocus')[0]
        Util.setCaretAtEnd input
    more:
      didBecomeVisible: (view) ->
        view.selectUrl()
    archive:
      didBecomeVisible: (view) ->
        input = view.$('.js-autofocus')[0]
        Util.setCaretAtEnd input

  viewNamed: (viewName, options) ->
    for { name, view } in @viewStack
      if viewName == name
        return view

    viewClass = _.result(@, 'sidebarSubviews')[viewName]
    if !viewClass?
      throw new Error "Unknown sidebar view #{viewName}"
    model = if viewName == 'filter' then @model.filter else @model
    new viewClass(_.extend({ model, @modelCache, sidebarView: @, viewState: options?.viewState }, options))

  topSidebarView: ->
    _.last(@viewStack).view

  topSidebarViewOptions: ->
    _.last(@viewStack).options

  renderView: (direction, callOnce) ->
    $title = @$('.js-board-menu-title')
    $titleIcon = @$('.js-board-menu-title-icon').empty()
    $titleText = @$('.js-board-menu-title-text').empty()
    $contentWrapper = @$('.js-board-menu-content-wrapper').empty().scrollTop(0)

    view = @topSidebarView()

    @$('.js-tab').removeClass('selected')
    @$('.js-tab').filter("[data-name='#{ _.last(@viewStack).name }']").addClass('selected')

    $contentWrapper.toggleClass('no-padding', view.noPadding == true)

    if view.headerDisplayTypeClass?
      @$('.js-board-menu-title').addClass(view.headerDisplayTypeClass)
    else
      @$('.js-board-menu-title').removeClass('is-board-menu-default-view')

    @$('.js-board-menu-title').toggleClass('is-top-level-tab',
      !!(simpleTest('tabbedBoardMenu')?.get('tabbed') && view.isTopLevelTab))

    $content = view.renderIfNecessary().$el

    if direction? then $content.addClass(direction)

    title = view.getViewTitle()
    if title
      $title.addClass('is-in-frame')
      $titleText.append title
    else
      $title.removeClass('is-in-frame')

    icon = view.viewIcon
    if icon && simpleTest('tabbedBoardMenu')?.get('tabbed')
      $titleIcon.append $('<span class="icon-lg">').addClass("icon-#{icon}")

    $contentWrapper.append($content)

    $extraTarget = @$('.js-board-menu-title-extra').empty()
    if simpleTest('tabbedBoardMenu')?.get('tabbed')
      view.setExtraTarget?($extraTarget)

    # this needs to be instantiated after the $contentWrapper has been cleared
    # of `.board-menu-content-frame`s and after inserting the current frame.
    # Otherwise, the transitionend triggers earlier on an old frame and we
    # don't get our didBecomeVisible.
    if callOnce?
      $('.board-menu-content-frame').one 'transitionend webkitTransitionEnd', (e) =>
        callOnce(view)

    @defer =>
      # without the defer, the browser removes the class too quickly and
      # doesn't animate. i think they are batched somehow.
      if direction? then $content.removeClass(direction)

    # the view can drop events, like when loading a bunch of other sidebar
    # views then using the 'f' shortcut, so reattach them here just in case.
    view.delegateEvents()

    @

  pushView: (name, viewOptions = {}, options = {}) ->
    { animate, showSidebar } = options
    animate ?= true
    showSidebar ?= true

    view = @viewNamed name, viewOptions

    if simpleTest('tabbedBoardMenu')?.get('tabbed') && @canRestoreTo(name)
      if name == 'default'
        Storage.unset(@_lastViewKey())
      else
        Storage.set(@_lastViewKey(), name)

    didBecomeVisible = @hackySidebarLifetimeEvents?[name]?.didBecomeVisible ? ->

    isCurrentTopView = view == @topSidebarView()
    isSidebarVisible = @model.viewState.get 'showSidebar'

    if !isSidebarVisible
      $('.board-menu').one 'transitionend webkitTransitionEnd', (e) =>
        didBecomeVisible view
    else if !isCurrentTopView
      callOnce = didBecomeVisible
    else
      didBecomeVisible view

    if showSidebar && !isSidebarVisible
      @model.viewState.setShowSidebar true

    if isCurrentTopView
      return

    @viewStack.push { name, view, options: viewOptions }
    direction =
      if animate
        if simpleTest('tabbedBoardMenu')?.get('tabbed') && view.isTopLevelTab
          'is-left-of-frame'
        else
          'is-right-of-frame'
    @renderView(direction, callOnce)
    PopOver.hide()
    return

  popView: ->
    if @viewStack.length == 1
      # This is fine -- the board view will try to call this if you hit
      # escape. There's no reason to let the board view know anything
      # about our view stack, as it's internal, so we just silently ignore
      # such a request.
      return

    resetView = @topSidebarViewOptions()?.resetTo
    if resetView
      return @resetTo(resetView)

    @topSidebarView().remove()
    @viewStack.pop()
    @renderView('is-left-of-frame')
    PopOver.hide()
    track("Board Menu", "Go Back a View")
    return

  resetTo: (view, options = {}) ->
    { animate } = options
    animate ?= true

    while @viewStack.length != 1
      @viewStack.pop()

    if view
      @pushView view, {}, options

    @renderView(if animate then 'is-left-of-frame')
    PopOver.hide()
    track("Board Menu", "Reset to #{view} view")
    return

  hideSidebar: ->
    @model.viewState.setShowSidebar(false)
    return



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-sidebar-view.coffee